import { useContextState } from '../../../../../hooks/theme'

export const useStyles = () => {
  const { colors } = useContextState()

  return {
    content: {
      display: 'flex',
      flex: 1,
      minHeight: 0,
      overflow: 'hidden',
      border: `1px solid ${colors.color39}`,
      borderRadius: '0px',
    },
    leftPanel: {
      display: 'flex',
      flexDirection: 'column',
      paddingBottom: '8px',
      gap: '8px',
      borderRight: `1px solid ${colors.color39}`,
      borderRadius: '4px',
      width: '35%',
      overflow: 'hidden',
      flexShrink: 0,
      minHeight: 0,
    },
    panelHeader: {
      padding: '8px 20px',
      fontSize: '16px',
      fontWeight: '600',
      color: colors.color13,
      backgroundColor: `${colors.color25}50`,
      borderBottom: `1px solid ${colors.color39}`,
    },
    searchField: {
      padding: '4px 12px 0 12px',
      width: '100%',
      '& .MuiOutlinedInput-root': { height: '40px', paddingLeft: '10px' },
    },
    itemsList: {
      display: 'flex',
      flexDirection: 'column',
      padding: '0 12px',
      gap: '8px',
      overflowY: 'auto',
      flex: 1,
      minHeight: 0,
    },
    itemRow: {
      display: 'flex',
      alignItems: 'center',
      border: `1px solid ${colors.color39}`,
      borderRadius: '4px',
      cursor: 'pointer',
    },
    itemLabel: {
      paddingLeft: '4px',
      fontSize: '16px',
      color: colors.color13,
    },
    rightPanel: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      padding: '16px',
      overflowY: 'auto',
      minHeight: 0,
    },
    emptyState: {
      margin: 'auto',
      fontSize: '16px',
      color: colors.color22,
    },
    selectedItemsList: {
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
    },
    selectedItemCard: {
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
    },
    selectedItemTitle: {
      fontSize: '16px',
      fontWeight: '600',
      color: colors.color13,
    },
  }
}
